module.exports = __webpack_public_path__ + "static/media/ic_categories_instrument.e9f64abe.svg";